/**
 * Connection-quality color/label from an Agora quality score - shared by the
 * imperative networkDot() string helper (videoGrid tile badges) and the React
 * People panel row dot, so the two can never disagree.
 */
export function networkQualityColor(score: number | null | undefined): {
  color: string;
  label: string;
} {
  if (typeof score === 'number' && score >= 1 && score <= 2)
    return { color: '#00d26a', label: 'good' };
  if (typeof score === 'number' && score >= 3 && score <= 4)
    return { color: '#ffb02e', label: 'fair' };
  if (typeof score === 'number' && score >= 5) return { color: '#f8312f', label: 'poor' };
  return { color: '#888', label: 'unknown' };
}
